export const sharedRoutePaths = {
  MAINTENANCE: 'maintenance',
  ERROR: 'error'
};
